import React, { useEffect } from "react";
import { Button } from "@mtm/components";
import "antd/dist/antd.css";
import {
  UpdateCCPRegistrationDetails,
  createPromoCodeCustomer,
  getPersonType,
  upsertPersonPersonRel,
} from "../../services/RegistrationService";
import {
  InsertParameter,
  PersonTypeIds,
  RegistrationEnums,
  ServicesTypesComponentLoad,
  TrackAnalytics,
  userType,
} from "../../types/ApplicationTypes";
import * as AppSettingsService from "../../services/AppSettingsService";
import Styles from "./MTMBenefitCheck.module.scss";
import { notification } from "antd";
import { upsertPersonOrganizationRel } from "../../services/TripService";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { ccpExtraDetailsInfo } from "../ServiceUsers/Interfaces/ITripDetails";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";


type Props = {
  setPageType: Function;
};

function MTMBenefitCheck({ setPageType }: Props) {
  const { caregiverSummaryInfo } = usePersonSummaryCtx();

  useEffect(() => {
    updateMatchBenefit();
    TrackAnalytics(
      "/Registration",
      "MTM Benefit Check - Myself",
      "MTM Benefit Check"
    );
  }, []);

  const appSettings = AppSettingsService;
  const { handleManageServiceUsersData } = useTripsCtx();

  async function updateMatchBenefit() {
    const data = {
      email: caregiverSummaryInfo.wandaEmail,
      MatchBenefit: true,
      insertParameter: InsertParameter.MatchBenefit,
      personId: caregiverSummaryInfo.personId,
    };
    handleUpdateCCPRegistrationDetails(data);
  }

 
  async function handleCheckBenefit() {
    const data = {
      email: caregiverSummaryInfo.wandaEmail,
      ViewBenefit: true,
      insertParameter: InsertParameter.ViewBenefit,
      personId: caregiverSummaryInfo.personId,
    };
    handleUpdateCCPRegistrationDetails(data);
    window.open(appSettings.getAppMapping().smp);
    handleUpdateRegisterFor();
  }

  async function handlePersonPersonRel() {
    try {
      const personRelData = {
        isActive: true,
        personId: caregiverSummaryInfo.personId,
        relatedPersonId: caregiverSummaryInfo.personId,
        relatedPersonTypeId: PersonTypeIds.wandaUser,
        relationshipRefId: RegistrationEnums.PersonRelationshipRefId,
      };
      await upsertPersonPersonRel(personRelData);
    } catch (error) {
      notification.error({
        message: "Error",
        description:
          "Failed to update person person relation for the caregiver.",
      });
    }
  }

  async function handleMTMBenefitSelect() {
    TrackAnalytics(
      "/Registration",
      "Myself Benefits – Continue Button Selected",
      "Myself Benefits"
    );

    Promise.all([handlePersonPersonRel(), handleUpdateRegisterFor()]);
    handleCreatePromoCodeCustomer();
    setPageType(ServicesTypesComponentLoad.TrustedContacts);
    await handleManageServiceUsersData();
  }

  async function handleUpdateRegisterFor() {
    const personTypes = await getPersonType(caregiverSummaryInfo.personId);
    if (personTypes) {
      const personType = personTypes.filter(
        (x: { personTypeId: Number }) =>
          x.personTypeId === PersonTypeIds.wandaUser
      );
      if (personType.length > 0 && !personType[0].isActive) {
        try {
          const request = {
            personOrganizationRelId: personType[0].personOrganizationRelId,
            organizationId: personType[0].organizationId,
            personId: caregiverSummaryInfo.personId,
            personTypeId: PersonTypeIds.wandaUser,
            relationshipRefId: personType[0].relationshipRefId,
            isActive: true,
          };
          await upsertPersonOrganizationRel(request);
        } catch (error) {
          notification.error({
            message: "Error",
            description:
              "Failed to update person organization relation data. Please try again later.",
          });
        }
      }
    }
  }

  async function handleUpdateCCPRegistrationDetails(data: ccpExtraDetailsInfo) {
    try {
      await UpdateCCPRegistrationDetails(data);
    } catch (error) {
      notification.error({
        message: "Error",
        description:
          "Failed to update registration status details. Please try again later.",
      });
    }
  }

  async function handleCreatePromoCodeCustomer(){
    try{
      await createPromoCodeCustomer(caregiverSummaryInfo.personId, userType.Caregiver);
    }catch{
      notification.error({
        message: "Error",
        description:
          "Failed to create customer. Please try again later.",
      });
    }
  }

  return (
    <div className={Styles.benefitCheckPosition}>
      <p className="subTextFont">
        <span className="subTextFont">You</span> may have medical benefits that
        you could take advantage of through our parent company, MTM.
      </p>
      <span>
        Would you like to check for benefits or continue signing up here?
      </span>
      <div className={Styles.benefitCheckButtonAlign}>
        <div className="zipModalButton">
          <Button
            clickHandler={handleCheckBenefit}
            className="cancelBtn"
            key="close"
          >
            Check Benefits
          </Button>
        </div>
        <div className="zipModalButtonSignup">
          <Button
            clickHandler={handleMTMBenefitSelect}
            className="saveBtn"
            key="close"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
export default MTMBenefitCheck;
